import Axios from "./config";

class Users {
  /**
   *
   * @param {*} id
   */
  getUsers(id = "") {
    return Axios.get(`/users/${id}`);
  }

  /**
   *
   * @param {*} formData
   */

  addUser(formData) {
    return Axios.post("/users/", formData);
  }

  /**
   *
   * @param {*} formData
   */
  updateUser(formData) {
    return Axios.put("/users/", formData);
  }

  /**
   *
   * @param {*} id
   */
  deleteUser(id) {
    return Axios.delete(`/users/${id}`);
  }
}

export default new Users();



// WEBPACK FOOTER //
// ./src/api/users.js